var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    "+_vm._s(_vm.formattedTiming)+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.formatDuration)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }